import "./NewsAgendaZonePP.module.css";
import NewsHero from "@/pages/PPZone/sections/NewsHero";
import Zonappherobulletin from "./sections/Zonappherobulletin";
import WartaAndActivities from "./sections/WartaAndActivities";
import Footer from "@/reusable_sections/Footer";
export default function NewsAgendaZonePPPage() {
  return <div>
      <NewsHero activePath="/zona-pp/warta-agenda" />
      <Zonappherobulletin />
      <WartaAndActivities />
      <Footer />
    </div>;
}